import Link from 'next/link';
import { twMerge } from 'tailwind-merge';

interface Props {
  title: string | JSX.Element;
  h1?: boolean;
  span?: boolean;
  extra?: JSX.Element;
  href?: string;
  target?: '_self' | '_blank';
  lineProps?: any;
  transparent?: boolean;
  classNames?: Partial<{
    wrapper: string;
    inner: string;
    text: string;
  }>;
}

export default function SectionTitle({title, href, extra, transparent, classNames, lineProps, span, target = '_blank'}: Props) {

  const titleJsx = (
    <div className={twMerge('flex items-center gap-x-[16px] w-fit', classNames?.inner)}>
      {span ? <span className={twMerge('text-dark dark:text-light leading-none', classNames?.text)}>{title}</span> : <h2 className={twMerge('text-dark dark:text-light leading-none', classNames?.text)}>{title}</h2>}
    </div>
  );
  return (
    <div>

    <div className={twMerge('w-fit h-fit flex flex-col gap-[6px]', classNames?.wrapper)}>
      {typeof title !== 'string' ? title : href ? <Link title={title} href={href} className='w-fit' target={target}>{titleJsx}</Link> : titleJsx}
      <div className='w-full h-[3px] bg-secondary dark:bg-primary'/>
      {/* {extra ? extra : null} */}
    </div>
    </div>
  )
}